import { parseCSV } from "../component/DocumentProcessor/parseUtils";

const RESPONSE_ROW_HEADERS = [
    "row_number",
    "clean_part_number",
    "qty",
    "price",
    "mfg",
    "dc",
    "lt",
    "remark",
    "analog",
    "overhead_costs"
];

export const serializeTableToCSV = (table) => {
    if (!table?.headers?.length || !Array.isArray(table?.data)) {
        return "";
    }

    const rows = table.data.map(row =>
        table.headers.map(header => row[header] ?? "").join(";")
    );

    return [table.headers.join(";"), ...rows].join("\n");
};

export const hydrateTableFromResponseRows = (rows) => {
    if (!Array.isArray(rows) || rows.length === 0) {
        return { headers: [], data: [] };
    }

    const responseHeaders = new Set(rows.flatMap(row => Object.keys(row || {})));
    const headers = [
        ...RESPONSE_ROW_HEADERS.filter(header => responseHeaders.has(header)),
        ...Array.from(responseHeaders).filter(header => !RESPONSE_ROW_HEADERS.includes(header))
    ];

    const data = rows.map(row => {
        const normalizedRow = {};
        headers.forEach(header => {
            normalizedRow[header] = row?.[header] ?? "";
        });
        normalizedRow._isErrorRow = false;
        return normalizedRow;
    });

    return { headers, data };
};

export const hydrateProcessedResult = (response) => {
    const table = Array.isArray(response?.rows) && response.rows.length > 0
        ? hydrateTableFromResponseRows(response.rows)
        : parseCSV(response?.processed);

    return {
        table,
        text: response?.processed || serializeTableToCSV(table)
    };
};

export const stripServiceFields = (row) => {
    const copy = { ...row };
    delete copy._isErrorRow;
    return copy;
};

export const buildDocumentSavePayload = ({
    fileName,
    processedTable,
    rawText,
    binaryFile = null,
    orderId = null
}) => {
    const headers = Array.isArray(processedTable?.headers) ? processedTable.headers : [];
    const rows = Array.isArray(processedTable?.data) ? processedTable.data : [];
    const cleanRows = rows.map(stripServiceFields);
    const processedData = cleanRows.length > 0
        ? [
            headers.join(";"),
            ...cleanRows.map(row => headers.map(header => row[header] ?? "").join(";"))
        ].join("\n")
        : "";

    const payload = {
        fileName,
        headers,
        rows: cleanRows,
        rawText: rawText || "",
        processedData,
        binaryFile,
        fileType: "excel",
        inputMode: rawText ? "text" : "excel",
        processedAt: new Date().toISOString()
    };

    if (orderId !== null && orderId !== undefined && orderId !== "") {
        payload.orderId = Number(orderId);
    }

    return payload;
};
